import React from 'react';
import ReactDOM from 'react-dom/client';
import '@fontsource-variable/cairo'; // خط Cairo من جوه السيستم (مش محتاج إنترنت لجوجل)
import './index.css';
import App from './App';
import { initTheme } from './theme';
import { initWideScroll } from './wideScroll';

initTheme();
initWideScroll();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);